import React from "react";

export const TagText = ({ className = "", text }) => <div className={`tag ${className}`}>{text}</div>;
